var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTripadvisorLogo = function SvgTripadvisorLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tripadvisor_logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10Zm-2.617-3.264L16.177 8.05a3.69 3.69 0 1 1-4.994 5.432L10 14.769 8.818 13.48A3.688 3.688 0 1 1 3.826 8.05L2.619 6.736h2.683A8.288 8.288 0 0 1 10 5.288c1.75 0 3.368.533 4.707 1.448h2.676Zm-13.567 4.04a2.496 2.496 0 1 0 4.991 0 2.496 2.496 0 0 0-4.991 0ZM7.23 7.047c1.577.602 2.771 2.012 2.771 3.655 0-1.643 1.195-3.052 2.77-3.655a7.168 7.168 0 0 0-2.77-.554c-.983 0-1.918.198-2.77.554Zm3.963 3.727a2.496 2.496 0 1 0 4.992.001 2.496 2.496 0 0 0-4.991 0Zm1.188 0a1.308 1.308 0 1 1 2.616-.002 1.308 1.308 0 0 1-2.616.001Zm-6.07 1.309a1.308 1.308 0 1 0 .002-2.616 1.308 1.308 0 0 0-.001 2.616Z",
    fill: "#D84339"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tripadvisor_logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgTripadvisorLogo;